import { Button, Modal, ModalBody, ModalContent } from "@heroui/react";
import ProposalSentIcon from "../../assets/proposal-sent-icon.svg?react";

export function ProposeTokenSuccessModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      placement="top"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
      hideCloseButton
    >
      <ModalContent>
        <ModalBody>
          <ProposalSentIcon className="size-24 mt-4" />
          <div className="font-semibold text-xl">Proposal sent!</div>
          <div className="font-[400] text-[#ADC0D0] text-sm text-center">
            Your token proposal has been sent! Please allow up to 3 days to review and accept it on the chain.
          </div>

          <Button fullWidth size="lg" color="primary" radius="full" className="mt-6" onPress={onClose}>
            Back to tokens
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
